<div class="displayFieldContainer">
  <label class="label">
    <span>{{ label }}</span>
  </label>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
